module.exports = __webpack_public_path__ + "static/media/blackberry_qnx.17feea67.svg";